<template>
    <a-badge :count="countMsg">
        <a-avatar
        :size="size"
        v-if="base64Image !== ''"
        :src="'data:image/png;base64,'+base64Image"
        />
        <a-avatar 
        :size="size"
        v-else
        >
            <template #icon>
                <AntDesignOutlined />
            </template>
        </a-avatar>
    </a-badge>
</template>
<script>
import { AntDesignOutlined } from '@ant-design/icons-vue';
export default {
    components: {
        AntDesignOutlined
    },
    props: {
        size: {
            default: { xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }
        },
        countMsg: {
            type: Number,
            default: 0
        },
        base64Image: {
            type: String,
            required: true
        }
    }
}
</script>